export default __webpack_public_path__ + "static/media/logo.114cf71e.jpg";